import LayerGroup from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import { urlWMSInundaciones, formatoPNG } from './configuracion';

const layer00379 = new TileLayer({
  title: 'Máscara 199109014',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19910914l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00379.setVisible(false);

const layer00378 = new TileLayer({
  title: 'Máscara 19911117',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19911117l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00378.setVisible(false);

const layer00377 = new TileLayer({
  title: 'Máscara 19920104',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19920104l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00377.setVisible(false);

const layer00376 = new TileLayer({
  title: 'Máscara 19920205',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19920205l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00376.setVisible(false);

const layer00375 = new TileLayer({
  title: 'Máscara 19920324',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19920324l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00375.setVisible(false);

const layer00374 = new TileLayer({
  title: 'Máscara 19920409',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19920409l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00374.setVisible(false);

const layer00373 = new TileLayer({
  title: 'Máscara 19920425',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19920425l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00373.setVisible(false);

const layer00372 = new TileLayer({
  title: 'Máscara 19920511',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19920511l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00372.setVisible(false);

const layer00371 = new TileLayer({
  title: 'Máscara 19920628',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19920628l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00371.setVisible(false);

const layer00370 = new TileLayer({
  title: 'Máscara 19920714',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19920714l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00370.setVisible(false);

const layer00369 = new TileLayer({
  title: 'Máscara 19920815',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19920815l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00369.setVisible(false);

export const grupoCapa01_30 = new LayerGroup({
  title: 'Ciclo Hidrológico 1991-1992',
  fold: 'close',
  layers: [layer00369, layer00370, layer00371, layer00372, layer00373, layer00374, layer00375, layer00376, layer00377, layer00378, layer00379]
});